// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"e94ff503","791":"e390732c"}[chunkId] + ".chunk.css";
};